module.exports = __webpack_public_path__ + "media/images/flags/64/Guernsey-44514e8aba2c154d32ba7934b64b70d2.png";